import CMSection from '@src/components/Atoms/CMSection';
import DonationCard from '@src/components/Molecules/Sponser/DonationCard';
import { donationCardList } from '@src/data/sponser';
import { devices } from '@src/styles/theme';
import styled from 'styled-components';

const Donation = () => {
  return (
    <CMSection background="#FFEDE8">
      <Wrap>
        <PcBigTitle>피플은 이런 수많은 환자를 돕고 있습니다</PcBigTitle>
        <MbBigTitle>
          피플은 이런 수많은 환자를
          <br /> 돕고 있습니다
        </MbBigTitle>
        <PcSubTitle>
          현재도 혈액이 긴급한 사연들이 피플에 혈액을 요청하고 있습니다.
          <br />
          환자들은 여러분의 도움에 절실히 의지하고 있습니다.
          <br />
          여러분의 도움의 손길이 간절하게 필요합니다.
        </PcSubTitle>
        <MbSubTitle>
          현재도 혈액이 긴급한 사연들이
          <br />
          피플에 혈액을 요청하고 있습니다.
          <br />
          환자들은 여러분의 도움에 절실히 의지하고 있습니다
          <br />
          여러분의 도움의 손길이 간절하게 필요합니다.
        </MbSubTitle>
        <CardWrap>
          {donationCardList.map((item, i) => (
            <DonationCard
              name={item.name}
              title={item.title}
              content={item.content}
              reNewCount={item.renew}
              blood={item.blood}
              donationType={item.donationType}
            />
          ))}
        </CardWrap>
      </Wrap>
    </CMSection>
  );
};

const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  gap: 50px;
  padding: 110px 0;

  @media ${devices.tablet} {
    padding: 50px 24px;
  }
`;

const PcBigTitle = styled.div`
  color: ${({ theme }) => theme.commonColor.black};
  text-align: center;
  font-family: 'NOTO';
  font-size: 47px;
  font-style: normal;
  font-weight: 500;
  line-height: 65px; /* 138.298% */
  letter-spacing: -1.41px;
  white-space: pre-wrap;
  display: block;
  @media ${devices.tablet} {
    display: none;
  }
`;

const MbBigTitle = styled.div`
  display: none;
  @media ${devices.tablet} {
    display: block;
    color: ${({ theme }) => theme.commonColor.black};
    text-align: center;
    font-family: 'NOTO';
    white-space: pre-wrap;
    font-size: 24px;
    line-height: 36px; /* 150% */
    letter-spacing: -0.72px;
  }
`;

const PcSubTitle = styled.div`
  color: ${({ theme }) => theme.commonColor.black};
  text-align: center;
  font-family: 'Var';
  font-size: 26px;
  font-style: normal;
  font-weight: 500;
  line-height: 40px; /* 153.846% */
  margin: 30px 0;
  display: block;
  @media ${devices.tablet} {
    display: none;
  }
`;

const MbSubTitle = styled.div`
  display: none;
  @media ${devices.tablet} {
    display: block;
    color: ${({ theme }) => theme.commonColor.black};
    text-align: center;
    font-family: 'Var';
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px; /* 150% */
  }
`;

const CardWrap = styled.div`
  max-width: 1200px;
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  > div {
    width: 590px;
    /* height: 300px; */
  }

  @media ${devices.tablet} {
    display: block;
    > div {
      width: 331px;
    }
    div:not(:first-child) {
      margin-top: 10px;
    }
  }
`;
export default Donation;
